import type { AuthUser } from '@/context/OnboarrdingContext';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from '@tanstack/react-router';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Space } from 'antd';
import { useTranslation } from 'react-i18next';
interface UserMenuProps {
  user: AuthUser;
  onLogout: () => void;
}

export function UserMenu({ user, onLogout }: UserMenuProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const items: MenuProps['items'] = [
    {
      key: 'user',
      label: (
        <div className="px-2 py-1">
          <p className="font-medium">{user.complete_name}</p>
          <p className="text-gray-500 text-sm">{user.email}</p>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: t('auth.profile'),
      onClick: () =>
        navigate({
          to: '/import-profile/edit-profile',
          search: { method: undefined },
        }),
    },
    {
      key: 'logout',
      danger: true,
      icon: <LogoutOutlined />,
      label: t('auth.logout'),
      onClick: onLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Space className="cursor-pointer">
        <Avatar src={user.photoUrl} />
      </Space>
    </Dropdown>
  );
}
